"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.User = void 0;
const contact_1 = require("./contact");
const account_1 = require("./account");
const typeorm_1 = require("typeorm/browser");
const user_role_enum_1 = require("./user-role-enum");
let User = class User {
    get isAdmin() {
        return this.role === user_role_enum_1.UserRoleEnum.ADMIN;
    }
    get isBrand() {
        return this.role === user_role_enum_1.UserRoleEnum.BRAND;
    }
    get isPartner() {
        return this.role === user_role_enum_1.UserRoleEnum.PARTNER;
    }
};
__decorate([
    (0, typeorm_1.PrimaryColumn)({
        name: 'contact_id',
    }),
    __metadata("design:type", String)
], User.prototype, "contactId", void 0);
__decorate([
    (0, typeorm_1.ViewColumn)(),
    __metadata("design:type", String)
], User.prototype, "role", void 0);
__decorate([
    (0, typeorm_1.ViewColumn)({
        name: 'account_id',
    }),
    __metadata("design:type", String)
], User.prototype, "accountId", void 0);
__decorate([
    (0, typeorm_1.OneToOne)(() => contact_1.Contact, {
        eager: true,
    }),
    (0, typeorm_1.JoinColumn)({
        name: 'contact_id',
    }),
    __metadata("design:type", contact_1.Contact)
], User.prototype, "contact", void 0);
__decorate([
    (0, typeorm_1.OneToOne)((type) => account_1.Account, {
        eager: true,
    }),
    (0, typeorm_1.JoinColumn)({
        name: 'account_id',
    }),
    __metadata("design:type", account_1.Account)
], User.prototype, "account", void 0);
User = __decorate([
    (0, typeorm_1.ViewEntity)({
        schema: 'public',
        name: 'user',
        expression: (connection) => {
            const qb = connection
                .createQueryBuilder()
                .select('role')
                .addSelect('account.id', 'account_id')
                .addSelect('contact.sfid', 'contact_id')
                .from(contact_1.Contact, 'contact')
                .innerJoin(account_1.Account, 'account', '(contact.accountid = account.id)')
                .where(`account.accountstatus__c IS NULL`)
                .orWhere(`account.accountstatus__c != 'Suspended'`);
            return qb;
        },
    })
], User);
exports.User = User;
//# sourceMappingURL=user.js.map